import { markdownToHtml } from "./markdown";

// Clean, unbranded PDF export for teachers. NO AulaPronta logo/name/URL/watermark.
// The output goes to sala de aula, then the teacher prints.
export function printMaterialToPDF(material, teacherName = "") {
  const html = markdownToHtml(material.conteudo || "");
  const win = window.open("", "_blank", "width=900,height=700");
  if (!win) return;
  const dateStr = new Date().toLocaleDateString("pt-BR");
  win.document.write(`<!doctype html>
<html lang="pt-BR"><head>
<meta charset="utf-8"/>
<title>${escapeHtml(material.titulo || "Material")}</title>
<style>
  * { box-sizing: border-box; }
  body { font-family: 'Segoe UI', Arial, sans-serif; color: #0f172a; margin: 0; padding: 24px 32px; }
  .doc-title { font-size: 22px; font-weight: 800; color: #0f172a; margin: 0 0 8px 0; border-bottom: 2px solid #0f172a; padding-bottom: 8px; }
  .meta { display:flex; flex-wrap:wrap; gap: 10px 24px; font-size: 13px; color:#334155; margin: 10px 0 16px 0; }
  .meta b { color:#0f172a; }
  h1 { font-size: 22px; color: #0f172a; margin: 6px 0 12px 0; }
  h2 { font-size: 17px; color: #0f172a; margin-top: 18px; }
  h3 { font-size: 14px; color: #334155; margin-top: 12px; }
  p, li { font-size: 13px; line-height: 1.55; }
  ul, ol { padding-left: 22px; }
  hr { border: none; border-top: 1px solid #cbd5e1; margin: 18px 0; }
  code { background:#f1f5f9; padding:2px 5px; border-radius:4px; font-size:12px; }
  @page { size: A4; margin: 16mm; }
</style>
</head><body>
  <h1 class="doc-title">${escapeHtml(material.titulo || "")}</h1>
  <div class="meta">
    ${material.disciplina ? `<div><b>Disciplina:</b> ${escapeHtml(material.disciplina)}</div>` : ""}
    ${material.serie ? `<div><b>Ano/Série:</b> ${escapeHtml(material.serie)}</div>` : ""}
    ${material.tema ? `<div><b>Tema:</b> ${escapeHtml(material.tema)}</div>` : ""}
    ${teacherName ? `<div><b>Professor(a):</b> ${escapeHtml(teacherName)}</div>` : ""}
    <div><b>Data:</b> ${dateStr}</div>
  </div>
  <div class="content">${html}</div>
  <script>window.onload = () => { setTimeout(() => window.print(), 300); };</script>
</body></html>`);
  win.document.close();
}

function escapeHtml(s) {
  return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
